import React from "react";

//components
import { Avatar } from "@performyard/py-components";

import Link from "../../../../../../components/Link";
import TruncatedText from "../../../../../../components/Text/TruncatedText";

// utils
import toEmployeeUrl from "../../../../../../utils/URLs/Employee";

import { Assignment } from "..";
// css
import css from "../Assignments.module.scss";

const ASSIGNMENTS_DATA_KEYS = [
	"current_author_assigned",
	"current_author_overdue_assigned",
	"waiting_author_assigned",
	"waiting_author_overdue",
	"current_signer_assigned",
	"current_signer_overdue_assigned",
	"waiting_signer_assigned",
	"waiting_signer_overdue",
];

const getAssignmentsCols = () => {
	const employeeCol = {
		id: "lower_name_sortable",
		label: "Employees",
		isSortable: true,
		isSticky: true,
		width: 230,
		getter: (assignment: Assignment) => {
			const { _id, name } = assignment;

			let renderedCell = (
				<Link href={toEmployeeUrl(_id)} forceHardReload={true}>
					<div className={css.userBox}>
						<Avatar size={20} dangerouslySetClassName={css.userAvatar} id={_id} alt={`${name}'s avatar`} />
						<div className={css.userName}>
							<TruncatedText
								useTooltip="never"
								maxWidth={220}
								size="paragraph-3"
								color="primary-5"
								weight="regular"
								text={name}
							/>
						</div>
					</div>
				</Link>
			);

			if (!name) {
				renderedCell = (
					<div className={css.unassigned}>
						<TruncatedText maxWidth={220} size="paragraph-3" weight="regular" text={"Unassigned"} />
					</div>
				);
			}

			return renderedCell;
		},
	};

	const dataCols = ASSIGNMENTS_DATA_KEYS.map((key, index) => {
		return {
			id: key,
			label: index % 2 === 0 ? "Assigned" : `Overdue`,
			isSortable: true,
			width: 94,
			getter: (assignment: Assignment) => {
				return assignment[key];
			},
		};
	});

	return [employeeCol, ...dataCols];
};

export const columnGroups = [
	{
		id: "employee",
		label: " ",
		columnSpan: 1,
	},
	{
		id: "currentAuthor",
		label: "Current Author",
		columnSpan: 2,
	},
	{
		id: "onDeckAuthor",
		label: "On Deck Author",
		columnSpan: 2,
	},
	{
		id: "currentSigner",
		label: "Current Signer",
		columnSpan: 2,
	},
	{
		id: "onDeckSigner",
		label: "On Deck Signer",
		columnSpan: 2,
	},
];

export default getAssignmentsCols;
